// extracted by mini-css-extract-plugin
module.exports = {"container":"LoyaltySoftGatePopup_container__rbINa","btns":"LoyaltySoftGatePopup_btns__GJveq","logoWrapper":"LoyaltySoftGatePopup_logoWrapper__5YWVr"};